var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bit-breaker",
    attrs: {
      "id": "million-bit-breaker"
    }
  }, [_c('div', {
    attrs: {
      "id": "game-menu"
    }
  }, [_c('div', [_c('span', {
    staticClass: "btn-group nav-buttons"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-house",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"
    }
  })])]), _vm._v(" "), (!_vm.isMuted) ? _c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mute(true)
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-volume-up-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isMuted) ? _c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mute(false)
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-volume-mute-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('h3', [_c('span', {
    attrs: {
      "id": "score-label"
    }
  }, [_vm._v("Score")]), _vm._v(" "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.score)
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "game-frame"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "gameCanvas",
      "width": "1024",
      "height": "1024"
    }
  }), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    attrs: {
      "id": "game-over"
    }
  }, [_c('h1', [_vm._v("Your Score "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.score)
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("High Score "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.highscore)
    }
  })]), _vm._v(" "), (_vm.score > 0) ? _c('a', {
    staticClass: "btn btn-block btn-lg btn-outline-light",
    attrs: {
      "href": _vm.xPost,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-lg btn-warning my-5",
    on: {
      "click": function($event) {
        return _vm.newGame();
      }
    }
  }, [_vm._v("New Game")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "game-leaderboard"
    }
  }, [_c('h3', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Leaderboard")]), _vm._v(" "), (!_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("Join the leaderboard by first connecting your wallet! "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-info mt-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.connectWallet()
      }
    }
  }, [_vm._v("\n                      Connect Wallet\n                  ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-block btn-outline-light my-3",
    class: {
      'disabled': this.leaderBoardToggle === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLeaderBoard()
      }
    }
  }, [_vm._v("\n                      This Week\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-outline-light my-3",
    class: {
      'disabled': this.leaderBoardToggle === 'week'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLeaderBoard()
      }
    }
  }, [_vm._v("\n                      All Time\n                  ")])]), _vm._v(" "), (_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("\n                  Player: \n                  "), (_vm.appData().connectedAccount.avatar) ? _c('img', {
    staticClass: "ensAvatar",
    staticStyle: {
      "max-height": "22px"
    },
    attrs: {
      "src": _vm.appData().connectedAccount.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appData().connectedAccount.name) ? _c('span', [_vm._v(_vm._s(_vm.appData().connectedAccount.name))]) : _vm._e(), _vm._v(" "), (!_vm.appData().connectedAccount.name) ? _c('span', [_vm._v(_vm._s(_vm.appData().connectedAccount.addressTrunc))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.gameLeaderboard.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gameLeaderboard), function(entry, index) {
    return _c('tr', {
      key: entry._id
    }, [_c('td', [_c('h5', {
      staticClass: "mr-1 honk-text"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(entry.player.avatar) ? _c('span', [_c('img', {
      staticClass: "ensAvatar",
      staticStyle: {
        "max-height": "22px"
      },
      attrs: {
        "src": entry.player.avatar
      }
    })]) : _vm._e(), _vm._v(" "), (entry.player.name) ? _c('span', [_vm._v(_vm._s(entry.player.name))]) : _vm._e(), _vm._v(" "), (!entry.player.name && entry.player.addressTrunc) ? _c('span', [_vm._v(_vm._s(entry.player.addressTrunc))]) : _vm._e(), _vm._v(" "), (!entry.player.name && !entry.player.addressTrunc) ? _c('span', [_vm._v("Anon")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('h4', {
      staticClass: "mr-1 honk-text"
    }, [(entry.didWin) ? _c('span', {
      staticClass: "pr-2"
    }, [_vm._v("🏆")]) : _vm._e(), _vm._v(_vm._s(entry.score))])])])
  })], 2)])]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "honk-text"
  }, [_vm._v("Million Bit Break")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-left"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Player")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Score")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74e162ad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Break.vue
// module id = FQQj
// module chunks = 2